import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-ui-accordion-item',
  template: `
    <div class="ui-accordion-item">
      <div class="ui-accordion-item__head" (click)="toggled.emit($event)">
        <p>{{ label() }}</p>
        <i class="fa" [class.fa-plus]="!open()" [class.fa-minus]="open()"></i>
      </div>
      <div class="ui-accordion-item__body" [class.ui-accordion-item__body--open]="open()">
        <ng-content />
      </div>
    </div>
  `,
  styleUrl: './ui-accordion-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiAccordionItemMoleculeComponent {
  readonly label = input.required<string>();
  readonly open = input(false);
  readonly toggled = output<Event>();
}
